import { Component, OnInit, ViewChild } from '@angular/core'
import { MatTabChangeEvent } from '@angular/material'
import { SectorProfitComponent } from 'app/industry-level/sector-profit/sector-profit.component'
@Component({
  selector: 'app-industry-level',
  templateUrl: './industry-level.component.html',
  styleUrls: ['./industry-level.component.scss']
})
export class IndustryLevelComponent implements OnInit {
  @ViewChild(SectorProfitComponent) sectorProfitComponent: SectorProfitComponent

  constructor() {}

  ngOnInit() {}
  onTabClick(event: MatTabChangeEvent) {
    localStorage.setItem('industrylevel', event.index.toString())
    switch (event.index) {
      case 0: // this.sectorProfitComponent.();;
        break
      case 1: // this.initialPublicOfferingComponent.initialChart();
        break
      case 2:
        break
      case 3: // this.profitComponent.initialChart();
        break
      default:
    }
  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/industry-level/industry-level/industry-level.component.ts